import { DeepPartial, PopularSearchesConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_POPULAR_SEARCHES: DeepPartial<PopularSearchesConfig> = {
  components: {
    container: 'CdlSuggestions',
    item: 'CdlTermSuggestion'
  }, size: 4
};
